import React from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";

import Banner from "./component/Banner";
import Footer from "./component/Footer";
import NotFound from "./view/NotFoundView";
import ANZHistoricalUnitPrices from "./view/historicalUnitPrices/ANZHistoricalUnitPrices";
import ANZUnitPrices from "./view/unitPrices/ANZUnitPrices";
import OnePathHistoricalUnitPrices from "./view/historicalUnitPrices/OnePathHistoricalUnitPrices";
import OnePathUnitPrices from "./view/unitPrices/OnePathUnitPrices";

class App extends React.Component {
  showIeErrorMessage = () => {
    const isEdge = window.navigator.userAgent.indexOf("Edge") !== -1;
    const isIE = window.navigator.userAgent.indexOf("Trident") !== -1 && !isEdge;

    if (!isIE) {
      return null;
    }

    return (
      <div className="bootstrap3-layout">
        <div className="container">
          <div
            className="alert alert-danger"
            role="alert"
            style={{ marginBottom: "0px", marginTop: "110px" }}
          >
            This page will not be compatible with Internet Explorer (IE11) from
            August. To continue viewing this page, please download and use the
            latest version of{" "}
            <a href="https://www.google.com/chrome/" target="_blank" rel="noreferrer">
              Chrome
            </a>{" "}
            or{" "}
            <a href="https://www.microsoft.com/en-us/edge" target="_blank" rel="noreferrer">
              Microsoft Edge
            </a>
            .
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="app">
        <div className="Site">
          <Banner />

          <div className="Site-content">
            {this.showIeErrorMessage()}

            <Router>
              <Switch>
                <Route exact path="/">
                  <Redirect to="/ANZUnitPrices" />
                </Route>

                <Route path="/ANZHistoricalUnitPrices" component={ANZHistoricalUnitPrices} />
                <Route path="/ANZUnitPrices" component={ANZUnitPrices} />
                <Route path="/HistoricalUnitPrices" component={OnePathHistoricalUnitPrices} />
                <Route path="/UnitPrices" component={OnePathUnitPrices} />
                <Route component={NotFound} />
              </Switch>
            </Router>
          </div>

          <Footer />
        </div>
      </div>
    );
  }
}

export default App;